import {Component, NgZone} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {IonicSelectableComponent} from 'ionic-selectable';

import {ValidatorProvider} from '../../providers/validator/validator';
import {AlertProvider} from '../../providers/alert/alert';
import {AuthProvider} from '../../providers/auth/auth';
import {UploadingProvider} from '../../providers/uploading/uploading';
import {TitleProvider} from '../../providers/title/title';
import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {EventEmitterProvider} from '../../providers/event-emitter/event-emitter';
import {ProofServerProvider} from "../../providers/proof-server/proof-server";
import {ProofBeforeBeginPage} from '../proof-before-begin/proof-before-begin';

import {RegistrationDocument} from '../../models/registrationdocument';
import {FileLikeObject, FileUploader} from 'ng2-file-upload';
import {Titledocument} from "../../models/titledocument";

import {RegistrationPersonal} from '../../models/registrationpersonal';

/**
 * Generated class for the UpdateRegistrationDocumentPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-update-title-document',
  templateUrl: 'update-title-document.html',
})
export class UpdateTitleDocumentPage {

  public fileUploader: FileUploader = new FileUploader({queueLimit: 10});
  public hasBaseDropZoneOver: boolean = false;

  private user: any;
  private proof: any;
  private hasApprovedCertification: boolean;
  public registrationDocument: RegistrationDocument;
  public titleDocument: Titledocument;
  public userFilesGet: any[] = [];
  public mandatoryDocumentation = '';

  public registrationPersonal: RegistrationPersonal;
  public titles: any[] = [];
  public titleId: any;
  public buttonContinue: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
    private eventEmitterProvider: EventEmitterProvider,
    private uploadingprovider: UploadingProvider,
    private zone: NgZone,
    private proofServerProvider: ProofServerProvider,
    private titleProvider: TitleProvider
  ) {
    this.titleId = 0;
    this.hasApprovedCertification = false;
    this.buttonContinue = navParams.get('buttonContinue');
    this.titleDocument = new Titledocument();

    this.user = this.authProvider.getUser();
    this.titleProvider.getTitles().subscribe(titles => {

      let arrTitles = [];
      titles.forEach((title) => {
        arrTitles.push(title)
      })

      this.titles = arrTitles;

    })

  }

  setTitle(event): void {
    this.titleId = event.value.id;
  }

  fileOverBase(event): void {
    this.hasBaseDropZoneOver = event;
  }

  getFiles(): FileLikeObject[] {
    return this.fileUploader.queue.map((fileItem) => {
      console.log('getFiles', fileItem.file);
      return fileItem.file;
    });
  }

  ionViewDidLoad() {
    this.checkFiles();
    console.log('ionViewDidLoad UpdateRegistrationDocumentPage');
  }

  checkFiles() {
    let loader = this.loadingCtrl.create({
      content: 'Obtendo Arquivos...',
      // duration: 3000
    });
    loader.present();

    this.uploadingprovider.listTitlesFiles(this.user.id).subscribe((response: any) => {
      if (response) {

        response.forEach(data => {
          this.titles.forEach(dt => {
            if (data.titleId == dt.id) {
              data.titleName = dt.name;
            }
          })
        })

        this.userFilesGet = response;

        this.userFilesGet.forEach((file) => {
          // if (file.validated === '1' || file.validated === null) {
          this.hasApprovedCertification = true;
          // }
        });

        console.log('listTitlesFiles response ->', this.userFilesGet);
        loader.dismiss();
      }
    }, (error: any) => {
      console.log(error);
      loader.dismiss();
      this.alertProvider.doAlert('Houve problemas ao tentar verificar se existem arquivos em anexo.', 'Atenção');
    });
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  onDocumentKindChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('document kind:', event.value);
  }

  onScholarityChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('scholarity:', event.value);
  }

  public doSave(): void {
    let countFiles: number = 0;
    this.fileUploader.queue.map((fileItem) => {
      countFiles++;
    });

    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar o documento.', 'Atenção');
    } else if (countFiles === 0) {
      this.alertProvider.doAlert('É necessário adicionar um arquivo para upload.', 'Atenção');
    }
    // else if (this.titleId === 0) {
    //   this.alertProvider.doAlert('É necessário selecionar um título para prosseguir.', 'Atenção');
    // }
    else {

      let that = this;
      this.alertProvider.doConfirm('Deseja salvar seu documento?', () => {
        let loader = that.loadingCtrl.create({
          content: 'Enviando pedido...',
          // duration: 3000
        });
        loader.present();

        let files = this.getFiles();

        if (files.length > 0) {

          files.forEach((file) => {
            let formData = new FormData();
            let userId = this.user.id;
            formData.append('file', file.rawFile);
            formData.append('titleId', this.titleId);
            /*formData.append('proofId', Config.proofId.toString());*/
            //formData.append('validaty', moment(this.titleDocument.validaty, 'DD/MM/YYYY').format('YYYY-MM-DD'));
            this.uploadingprovider.uploadFormTitleData(formData, userId).subscribe((response: any) => {
              if ((response) && (response.updated)) {
                loader.dismiss();
                this.checkFiles();
                console.log("updateTitleDocument", response);
              }else if(response.updated == false){
                this.alertProvider.doAlert(response.error, 'Atenção');
                loader.dismiss();
              }              

            });
          });

        }


      });

    }
  }

  removeFile(fileId) {
    this.uploadingprovider.removeTitleFile(fileId).subscribe((response: any) => {
      if ((response) && (response.updated)) {
        //loader.dismiss();
        this.checkFiles();
        console.log("removeTitleFile", response);
      }
    });
  }

  reprovedDescription(msg) {
    this.alertProvider.doAlert(msg, 'Motivo de Reprovação');
  }
  
  public doContinue(): void {
    console.log(this.userFilesGet.length)
    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar o documento.', 'Atenção');
    } else if (this.userFilesGet.length < 1) {
      this.alertProvider.doAlert('É necessário adicionar um arquivo para upload.', 'Atenção');
    }else {
      this.navCtrl.push(ProofBeforeBeginPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/update-title-document/update-title-document.ts